import React, { useEffect, useState } from 'react';
import Card from '../CarLineCard/Card';

import { useInitialState } from '../../context/InitialStateContext';
import { useAppContext } from '../../context/Context';
import { Foldout, StyledCarlineGrid } from './CarlineStyles';
import ExploreCompareButtons from '../ExploreCompareButtons/ExploreCompareButtons';

interface CarlineProps {
  onKeyDown: (event: KeyboardEvent) => void;
}

const CarLine: React.FC<CarlineProps> = ({ onKeyDown }) => {
  const { carlineGroups } = useInitialState();
  const { selectedCarGroupId, carlineCardMenuRef } = useAppContext();
  const { filteredCarlineGroups } = useAppContext();

  const carlineGroupsToDisplay = filteredCarlineGroups || carlineGroups;
  const selectedCarGroup = carlineGroupsToDisplay.find((group) => group.id === selectedCarGroupId);
  const carlines = selectedCarGroup ? selectedCarGroup.carlines : [];

  const [actualHeight, setActualHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      const contentElement = carlineCardMenuRef.current?.scrollHeight || 0;
      const newHeight = contentElement;

      setActualHeight((prevHeight) => {
        // Use prevHeight to ensure we're using the previous state
        return newHeight !== prevHeight ? newHeight : prevHeight;
      });
    };
    updateHeight();
    const timeoutId = setTimeout(updateHeight, 100);

    const handleResize = () => {
      clearTimeout(timeoutId);
      setTimeout(updateHeight, 100);
    };
    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });

    if (carlineCardMenuRef.current) {
      resizeObserver.observe(carlineCardMenuRef.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [selectedCarGroupId, carlineCardMenuRef.current?.scrollHeight]);

  useEffect(() => {
    const keyDownHandler = (event: KeyboardEvent) => {
      onKeyDown(event);
    };
    window.addEventListener('keydown', keyDownHandler);
    return () => {
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, [selectedCarGroupId]);

  return (
    <Foldout actualHeight={actualHeight}>
      <div ref={carlineCardMenuRef}>
        <StyledCarlineGrid isActive={selectedCarGroupId !== undefined}>
          {selectedCarGroup &&
            carlines.map((carline, index) => (
              <Card
                key={`${carline.id}-${index}`}
                carline={carline}
                carlineGroup={selectedCarGroup}
                lazyImage
              />
            ))}
        </StyledCarlineGrid>
        <ExploreCompareButtons inFoldout isFoldoutOpen={selectedCarGroupId !== undefined} />
      </div>
    </Foldout>
  );
};

export default CarLine;
